import { IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";

type Props = {
  open: boolean;
  onClose: () => void;
};

const saudiCities = [
  "Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Khobar",
  "Dhahran", "Hofuf", "Al-Ahsa", "Taif", "Tabuk", "Hail", "Buraidah",
  "Abha", "Khamis Mushait", "Najran", "Jazan", "Yanbu", "Al-Jubail",
  "Al-Qatif", "Sakakah", "Arar", "Al-Bahah", "Al-Muzahimiyah", "Unaizah",
  "Al-Kharj", "Al-Mubarraz", "Al-Kunfudhah", "Al-Ula", "Al-Wajh", "Al-Leith",
  "Rabigh", "Al-Bukayriyah", "Turaif", "Sharurah", "Rafha", "Qurayyat",
  "Al-Namas", "Al-Mikhwah", "Baljurashi", "Mahd adh Dhahab", "Al-Qunfudhah"
];

const ViewCitiesModal = ({ open, onClose }: Props) => {
  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl w-[655px]">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h1 className="text-2xl">View Cities ({saudiCities.length})</h1>
          <button
            onClick={onClose}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="w-full max-h-[520px] overflow-y-auto p-4 space-y-4">
          <NormalSearch />
          <div className="flex flex-wrap gap-4">
            {saudiCities.map((city) => (
              <div
                key={city}
                className="bg-[#FBD037]/20 border border-[#FBD037] px-4 py-1 rounded-full"
              >
                {city}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCitiesModal;
